import State from 'interfaces/state/State';

export const isError$ = (state: State): boolean => state.subscriptionLimit.isError;
export const isLoading$ = (state: State): boolean => state.subscriptionLimit.isLoading;
export const subscrLimits$ = (state: State): string[] => state.subscriptionLimit.list;
